import { COLUMN_CODE, TableManger, TABLES } from "./TableManger";

import Table from "../services/table";
import Utility from "../utility/Utility";

export class PipelineManager {
  static pipelines: any = {};
  static filterConditions: any = [];
  static stageMetaData: any = [];

  static get(refresh = true): Promise<any> {
    let options = {
      colIdsToFetchRef: TableManger.getColumnId(
        TABLES.PIPELINE,
        COLUMN_CODE.PIPELINE.STAGE_ID_S
      ),
    };
    const pipelineTableId = TableManger.getTableId(TABLES.PIPELINE);
    if (refresh || this.pipelines?.data?.length === 0) {
      PipelineManager.getStageMetaData();
      return Table.getRecordsByPage(options, null, pipelineTableId).then(
        (res) => {
          this.set(res);
          return Promise.resolve(res);
        }
      );
    } else {
      return Promise.resolve(this.pipelines);
    }
  }
  static set(pipeline) {
    this.pipelines = pipeline;
  }
  static clear() {
    this.set({});
  }
  static processPipelineData() {
    let dataToReturn = [];
    const pipelineNameColId = TableManger.getColumnId(
      TABLES.PIPELINE,
      COLUMN_CODE.PIPELINE.NAME
    );
    const stageColumnId = TableManger.getColumnId(
      TABLES.PIPELINE,
      COLUMN_CODE.PIPELINE.STAGE_ID_S
    );
    const stageNameColumnId = TableManger.getColumnId(
      TABLES.STAGE,
      COLUMN_CODE.STAGES.NAME
    );
    const stageDetailsKey = `${stageColumnId}_detail`;
    if (this.pipelines && this.pipelines.data) {
      this.pipelines.data.forEach((pipeline) => {
        let pipelineData = {};
        pipelineData["id"] = pipeline._id;
        pipelineData["name"] = pipeline.cells[pipelineNameColId];
        pipelineData["stages"] = pipeline.cells[stageDetailsKey].map(
          (stage) => {
            return {
              id: stage._id,
              name: stage.cells[stageNameColumnId],
            };
          }
        );
        dataToReturn.push(pipelineData);
      });
    }
    return dataToReturn;
  }

  static getStagesForCurrentPipeline() {
    const pipelines = this.processPipelineData();
    if (!pipelines?.length) return [];

    let currentSelectedPipelineIndex = Utility.isEmptyObject(
      Utility.getPersistentValue('selectedPipeline')
    )
      ? 0
      : parseInt(
          Utility.getPersistentValue('selectedPipeline')
        );

    return pipelines[currentSelectedPipelineIndex]?.stages || [];
  }
  static getStageMetaData = async (payload?: any, params = {}) => {
    try {
      PipelineManager.stageMetaData = await Table.fetchStageMetaData(payload, params);
    } catch(err) {
      PipelineManager.stageMetaData = [];
    }
  }
}
